/**
 * Generated by orval v8.5.2 🍺
 * Do not edit manually.
 * VirtualBrain Chatbot API
 * API for chatbot interactions, authentication, and AI completions
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
	MutationFunction,
	QueryClient,
	UseMutationOptions,
	UseMutationResult,
} from "@tanstack/react-query";


import { chatbotApiAxiosInstance } from "../../../../chatbot-api/axios-instance";
import type { ErrorType } from "../../../../chatbot-api/axios-instance";
import type { AuthResponse } from "../../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Creates a new anonymous session and returns a JWT token, for public chatbots
 * @summary Authenticate with a chatbot
 */
export const authControllerLoginV1 = async (
	id: string,
	options?: SecondParameter<typeof chatbotApiAxiosInstance>,
	signal?: AbortSignal,
) => chatbotApiAxiosInstance<AuthResponse>(
		{ url: `/v1/auth/${id}`, method: "POST", signal },
		options,
	);

export const getAuthControllerLoginV1MutationOptions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof authControllerLoginV1>>,
		TError,
		{ id: string },
		TContext
	>;
	request?: SecondParameter<typeof chatbotApiAxiosInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof authControllerLoginV1>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ["authControllerLoginV1"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof authControllerLoginV1>>,
		{ id: string }
	> = async (props) => {
		const { id } = props ?? {};

		return authControllerLoginV1(id, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AuthControllerLoginV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof authControllerLoginV1>>
>;

export type AuthControllerLoginV1MutationError = ErrorType<void>;

/**
 * @summary Authenticate with a chatbot
 */
export const useAuthControllerLoginV1 = <TError = ErrorType<void>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof authControllerLoginV1>>,
			TError,
			{ id: string },
			TContext
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof authControllerLoginV1>>,
	TError,
	{ id: string },
	TContext
> => useMutation(getAuthControllerLoginV1MutationOptions(options), queryClient);

/**
 * Creates a preview session for authenticated users
 * @summary Authenticate in preview mode
 */
export const authControllerLoginPreviewV1 = async (
	id: string,
	options?: SecondParameter<typeof chatbotApiAxiosInstance>,
	signal?: AbortSignal,
) => chatbotApiAxiosInstance<AuthResponse>(
		{ url: `/v1/auth/${id}/preview`, method: "POST", signal },
		options,
	);

export const getAuthControllerLoginPreviewV1MutationOptions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof authControllerLoginPreviewV1>>,
		TError,
		{ id: string },
		TContext
	>;
	request?: SecondParameter<typeof chatbotApiAxiosInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof authControllerLoginPreviewV1>>,
	TError,
	{ id: string },
	TContext
> => {
	const mutationKey = ["authControllerLoginPreviewV1"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof authControllerLoginPreviewV1>>,
		{ id: string }
	> = async (props) => {
		const { id } = props ?? {};

		return authControllerLoginPreviewV1(id, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AuthControllerLoginPreviewV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof authControllerLoginPreviewV1>>
>;

export type AuthControllerLoginPreviewV1MutationError = ErrorType<void>;

/**
 * @summary Authenticate in preview mode
 */
export const useAuthControllerLoginPreviewV1 = <TError = ErrorType<void>, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof authControllerLoginPreviewV1>>,
			TError,
			{ id: string },
			TContext
		>;
		request?: SecondParameter<typeof chatbotApiAxiosInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof authControllerLoginPreviewV1>>,
	TError,
	{ id: string },
	TContext
> => useMutation(getAuthControllerLoginPreviewV1MutationOptions(options), queryClient);
